import { useMemo, useState } from "react";
import { Wallet } from "lucide-react";
import "./LumpsumCalculator.css";

const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Math.round(n));

export default function LumpsumCalculator() {
  const [principal, setPrincipal] = useState(100000);
  const [rate, setRate] = useState(12);
  const [years, setYears] = useState(10);

  const { fv, gains } = useMemo(() => {
    const future = principal * Math.pow(1 + rate / 100, years);
    return { fv: future, gains: future - principal };
  }, [principal, rate, years]);

  return (
    <section className="calc-card" id="lumpsum">
      <div className="calc-card__head">
        <div className="calc-card__icon">
          <Wallet size={22} />
        </div>
        <div>
          <h2>Lumpsum Calculator</h2>
          <p>Project growth of a one-time investment compounded annually.</p>
        </div>
      </div>

      <div className="calc-layout">
        <div>
          <div className="calc-field">
            <div className="calc-field__top">
              <label htmlFor="ls-p">Investment amount</label>
              <input
                id="ls-p"
                className="calc-field__input"
                type="number"
                min={1000}
                max={100000000}
                step={1000}
                value={principal}
                onChange={(e) => setPrincipal(Number(e.target.value) || 0)}
              />
            </div>
            <input
              className="calc-range"
              type="range"
              min={1000}
              max={5000000}
              step={1000}
              value={Math.min(principal, 5000000)}
              onChange={(e) => setPrincipal(Number(e.target.value))}
            />
          </div>
          <div className="calc-field">
            <div className="calc-field__top">
              <label htmlFor="ls-r">Expected return (% p.a.)</label>
              <input
                id="ls-r"
                className="calc-field__input"
                type="number"
                min={1}
                max={30}
                step={0.5}
                value={rate}
                onChange={(e) => setRate(Number(e.target.value) || 0)}
              />
            </div>
            <input
              className="calc-range"
              type="range"
              min={1}
              max={30}
              step={0.5}
              value={rate}
              onChange={(e) => setRate(Number(e.target.value))}
            />
          </div>
          <div className="calc-field">
            <div className="calc-field__top">
              <label htmlFor="ls-y">Time period (years)</label>
              <input
                id="ls-y"
                className="calc-field__input"
                type="number"
                min={1}
                max={40}
                value={years}
                onChange={(e) => setYears(Number(e.target.value) || 1)}
              />
            </div>
            <input
              className="calc-range"
              type="range"
              min={1}
              max={40}
              value={years}
              onChange={(e) => setYears(Number(e.target.value))}
            />
          </div>
        </div>

        <div className="calc-results">
          <div className="calc-result">
            <span>Invested</span>
            <strong>{formatINR(principal)}</strong>
          </div>
          <div className="calc-result">
            <span>Est. returns</span>
            <strong>{formatINR(gains)}</strong>
          </div>
          <div className="calc-result calc-result--accent">
            <span>Future value</span>
            <strong>{formatINR(fv)}</strong>
          </div>
          <p className="calc-note">FV = P × (1 + r)ⁿ</p>
        </div>
      </div>
    </section>
  );
}
